import { Heading } from '../../r2/Heading';
import { Text } from '../../r2/Text';
import { Button } from '../../r2/Button';
import { Icon } from '../../r2/Icon';
import styles from './PricingCard.module.css';

export interface PricingCardProps {
  planName: string;
  subtitle?: string;
  price: string;
  term?: string;
  features: string[];
  ctaLabel: string;
  onCtaClick?: () => void;
}

export function PricingCard({
  planName,
  subtitle,
  price,
  term = '/mo',
  features,
  ctaLabel,
  onCtaClick,
}: PricingCardProps) {
  return (
    <div data-crd-id="r3.bq-pricing-card" data-crd-layer="r3" className={styles.card}>
      <div className={styles.header}>
        <div className={styles.planInfo}>
          <Heading level={3} as={3}>
            {planName}
          </Heading>
          {subtitle && (
            <Text size="r2" color="n700">
              {subtitle}
            </Text>
          )}
        </div>
        <div className={styles.price}>
          <span className={styles.priceAmount}>{price}</span>
          <span className={styles.priceTerm}>{term}</span>
        </div>
      </div>

      <div className={styles.divider} />

      <Text size="r2" color="n500">
        Includes:
      </Text>

      <ul className={styles.featureList}>
        {features.map((feature) => (
          <li key={feature} className={styles.featureItem}>
            <Icon name="check" size="sm" color="p500" />
            <Text size="r2" as="span">
              {feature}
            </Text>
          </li>
        ))}
      </ul>

      <div className={styles.divider} />

      <Button variant="primary" size="large" onClick={onCtaClick}>
        {ctaLabel}
      </Button>
    </div>
  );
}
